/**
 * items: Radio's items    object array(필수)
 *     ex) [ { value: "0", name: "Hwang" }, { value: "1", name: "Lee", checked: true }, { value: "2", name: "Kim" } ]
 *       => index 2's checked true == item checked
 * containerStyle: Radio's containerStyle    object
 * inputStyle: Radio's inputStyle    object
 * labelStyle: Radio's labelStyle    object
 * value: Radio's value    state
 * onChange: Radio's change evnet    function(필수)
 * gubun: Radio's distinguisher if there are more than one BasicRadio    string
 * disabled: Radio's disabled    boolean
 *
 */

import React from "react";

function BasicRadio({
  items = [],
  containerStyle,
  inputStyle,
  labelStyle,
  value,
  onChange,
  gubun,
  disabled,
  style,
  name,
}) {
  const RadioChange = (e) => {
    onChange(e);
  };
  const [containerStyle2, setContainerStyle2] = React.useState({
    flexWrap: "noWrap",
    width: "65px",
  });
  return (
    <div style={style}>
      {name === "" ? null : <label style={labelStyle}>{name}</label>}
      {items.map((item, index) => {
        if (item.value == "0" || item.value == "1") {
          return (
            <div key={index} style={containerStyle2}>
              <input
                id={"radioInput" + index + gubun}
                style={inputStyle}
                type="radio"
                name={"radioInput" + gubun}
                value={item.value}
                onChange={RadioChange}
                checked={value === item.value}
                disabled={disabled}
              />
              <label style={labelStyle} htmlFor={"radioInput" + index + gubun}>
                {item.name ? item.name : ""}
              </label>
            </div>
          );
        } else {
          return (
            <div key={index} style={containerStyle}>
              <input
                id={"radioInput" + index + gubun}
                style={inputStyle}
                type="radio"
                name={"radioInput" + gubun}
                value={item.value}
                onChange={RadioChange}
                checked={value === item.value}
                disabled={disabled}
              />
              <label style={labelStyle} htmlFor={"radioInput" + index + gubun}>
                {item.name ? item.name : ""}
              </label>
            </div>
          );
        }
      })}
    </div>
  );
}

BasicRadio.defaultProps = {
  containerStyle: {
    margin: "0 5px",
  },
  inputStyle: {},
  labelStyle: {
    margin: "0 5px",
    fontSize: "15px",
    fontFamily: "s-core-dream-Medium",
  },
  gubun: "0",
  disabled: false,
};

export default BasicRadio;
